import {ConsentManagerBuilder, savePreferences} from '@segment/consent-manager'
//import type {CategoryPreferences} from '@segment/consent-manager/types/types'
import React from 'react'

import {isBrowser} from '@helios/shared/utils/browser'

import type {CookieBannerContent} from './cookie-banner-v2'
import {CookieBanner} from './cookie-banner-v2'
//import {cookieCategoriesMapping} from '../../config/cookies'

interface Props {
    content: CookieBannerContent
    withOverlay?: boolean
}

const FooterBannerWrapper = ({content, withOverlay}: Props) => {
    const [showFallbackBanner, setShowFallbackBanner] = React.useState(false)

    /*
    const cookieDestinations = content.cookieCategories.reduce((acc, cur) => {
        if (cur && cur.data.cookies?.length) {
            const cookies = cur.data?.cookies.map((cookie) => ({
                ...cookie,
                category: cookieCategoriesMapping[cur.key],
            }))
            return [...acc, ...cookies]
        }
        return acc
    }, [] as CookieBannerContent['cookieCategories'][0]['data']['cookies'])
   

    const setAllTo = (condition: boolean) => ({
        necessary: true,
        functional: condition,
        marketing: condition,
        performance: condition,
    })

    
    const initialPreferences: CategoryPreferences = {
        necessary: true,
        functional: false,
        marketing: false,
        performance: false,
    }
  
    const mapCustomPreferences = (_: any[], preferences: CategoryPreferences) => {
        const destinationPreferences: CategoryPreferences = {}
        cookieDestinations.forEach((destination: any) => {
            destinationPreferences[destination.id] = preferences[destination.category]
        })

        return {destinationPreferences, customPreferences: preferences}
    }
    */

    // If Segment fails to load, we still show the cookie banner and allow
    // to save the preferences in a cookie
    if (showFallbackBanner) {
        return (
            <CookieBanner
                content={content}
                withOverlay={Boolean(withOverlay)}
                saveConsent={() => {}}
                setPreferences={(preferences) =>
                    savePreferences({destinationPreferences: preferences})
                }
                //acceptAll={setAllTo(true)}
                //denyAll={setAllTo(false)}
                newDestinations={[]}
                preferences={{}}
            />
        )
    }

    return (
        <ConsentManagerBuilder
            writeKey={process.env.GATSBY_SEGMENT_WRITE_KEY!}
            shouldRequireConsent={() => (isBrowser && window._DATADOG_SYNTHETICS_BROWSER) || false}
            //initialPreferences={initialPreferences}
            //mapCustomPreferences={mapCustomPreferences}
            onError={() => setShowFallbackBanner(true)}
        >
            {(consentProps) => (
                <CookieBanner
                    withOverlay={Boolean(withOverlay)}
                    content={content}
                    //acceptAll={setAllTo(true)}
                    //denyAll={setAllTo(false)}
                    {...consentProps}
                />
            )}
        </ConsentManagerBuilder>
    )
}

export default FooterBannerWrapper
